import Image from "next/image";
import Link from "next/link";



const HeroTwo = () => {

  return (
    <div className="main-banner-area ">
      <div className="container">
        <div
          className="main-banner-content  text-center position-relative"
          data-cues="slideInUp"
          data-group="bannerContent"
        >
          <h1>A Center of Excellence for Health Science Education</h1>
          <p className="mx-auto fs-5">
               We mainly deal in promotion of Vocational and Professional and Paramedical Educational programs
          </p>
          <div className="btn-box">
            <Link href="contact" className="default-btn ">
              Get In Touch
            </Link>
            {/* <Link href="courses" className="default-btn ">
              Enroll Now
            </Link> */}
          </div>
           <div className="shape4">
        <Image
          width={100}
          height={87}
          sizes="100vw"
          src="/images/shapes/shape4.svg"
          alt="shape4"
        />
      </div>
      <div className="shape5">
        <Image
          width={121}
          height={164}
          sizes="100vw"
          src="/images/shapes/shape5.svg"
          alt="shape5"
        />
      </div>
        </div>
        <div className="main-banner-image text-center" data-cue="slideInUp">
          <Image
            width={1296}
            height={387}
            sizes="100vw"
            src="/images/banners/banner01.jpg"
            alt="banner-image"
          />
        </div>
     
      </div>
    </div>
  );
};

export default HeroTwo;
